import type { HTMLPalmUiElement, PalmUiConfiguration } from '@innovatrics/dot-auto-capture-ui/palm';

import '@innovatrics/dot-auto-capture-ui/palm';
import { useEffect } from 'react';

/*
 * SAIDVU-499/501 — companion guidance UI for the DOT web palm auto-capture, mirroring `FaceCameraUi`
 * (`@innovatrics/dot-auto-capture-ui/face`). The `<x-dot-palm-capture-ui>` element listens to the
 * capture component's detection/instruction events and renders the real-time positioning hints
 * (move closer / hold still / more light …), the left/right hand placeholder outline, and the
 * camera control buttons — the same well-tuned overlay the face step relies on. Without it the user
 * gets no feedback on why auto-capture is not firing, which is why the raw component felt "stuck".
 */
export const PalmCameraUi = (props: PalmUiConfiguration) => {
  useEffect(() => {
    const uiElement = document.getElementById('x-dot-palm-capture-ui') as HTMLPalmUiElement | null;

    if (uiElement) {
      uiElement.configuration = props;
    }
  });

  return <x-dot-palm-capture-ui id="x-dot-palm-capture-ui" />;
};
